import { createContext, useContext } from "react";

import { HISTORY_SOURCES } from "../../constants";
import type { CaptainBillingHistorySource } from "../../types";

export const HistorySourceContext = createContext<CaptainBillingHistorySource | undefined>(undefined);

export const useHistorySource = () => useContext(HistorySourceContext);

export const isHistorySource = (value: string | null): value is CaptainBillingHistorySource =>
  (HISTORY_SOURCES as (string | null)[]).includes(value);
